import { Component } from '@angular/core';

@Component({
    selector: 'app-blank',
    templateUrl: './blank.component.html',
    styleUrls: [
        'blank.component.scss',
    ],
    standalone: false
})
export class BlankComponent {

  constructor() {

  }

}
